// export const HOST = 'https://test.mwork365.cloud';
export const HOST = "";

export const MAIN_API_ROOT = `/main/api`;
export const MAIN_IMAGE_ROOT = `/main`;
export const LOCAL_TRANSLATION_ROOT = `http://localhost:8099`;
export const PRODUCTION_TRANSLATION_ROOT = "https://translations.mwork365.com";

// Replace it in index.css if change
export const defaultPrimaryColor = "#ff6105";
export const defaultPrimaryAccentColor = "#db500b";
